(function() {
if (window._vmPickerLoaded) return;
window._vmPickerLoaded = true;

// All supplements are subscription-only (Seal Subscriptions), so every cart item
// must carry a selling_plan. The plan id and the base VitaMonth variant id are
// injected by vitamonth-picker-embed.liquid, with known-good fallbacks.
var pickerOuterEl = document.getElementById('vm-picker-outer');
var SELLING_PLAN = parseInt((pickerOuterEl && pickerOuterEl.dataset.sellingPlan) || '689418469715', 10);
var BASE_VARIANT = parseInt((pickerOuterEl && pickerOuterEl.dataset.baseVariant) || '49248861913427', 10);
var BASE_PRICE = 4.99;

// helpers
function show(el) { if (el) el.style.display = ''; }
function hide(el) { if (el) el.style.display = 'none'; }
function isHidden(el) { return !el || el.style.display === 'none'; }

// Wire up A-Z toggle FIRST (before anything that could throw)
var azToggle = document.getElementById('vm-az-toggle');
var azBody   = document.getElementById('vm-az-body');
if (azToggle && azBody) {
  azToggle.addEventListener('click', function() {
    var opening = isHidden(azBody);
    if (opening) { show(azBody); } else { hide(azBody); }
    azToggle.setAttribute('aria-expanded', String(opening));
    azToggle.querySelector('.vm-picker__cat-arrow').textContent = opening ? '▴' : '▾';
  });
}

var BENEFITS   = window.vmBenefits   || {};
var CATEGORIES = window.vmCategories || [];
var NUTRITION  = window.vmNutrition  || {};
var SUPPLEMENTS = [];
var sorted = [];
var selected = new Set();

// Resize a Shopify CDN image url (from products.json) to a small thumbnail
function thumbUrl(src, width) {
  if (!src) return '';
  try {
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + (width || 240);
  } catch(e) { return src; }
}

function processProducts(products) {
  var supplements = products.filter(function(p) {
    return Array.isArray(p.tags) && p.tags.indexOf('supplement') !== -1;
  });
  SUPPLEMENTS = supplements.map(function(p) {
    var cats = (p.tags || []).filter(function(t) {
      return t.indexOf('cat:') === 0;
    }).map(function(t) { return t.replace('cat:', ''); });
    var price = '';
    if (p.variants && p.variants[0] && p.variants[0].price) {
      price = '£' + parseFloat(p.variants[0].price).toFixed(2);
    }
    var variantId = (p.variants && p.variants[0]) ? p.variants[0].id : 0;
    var img = (p.images && p.images[0] && p.images[0].src) ? thumbUrl(p.images[0].src, 240) : '';
    return { name: p.title, handle: p.handle, price: price, variantId: variantId, img: img, cats: cats };
  });
  sorted = SUPPLEMENTS.slice().sort(function(a, b) { return a.name.localeCompare(b.name); });
}

// Quiz deep link: pre-select supplements from ?vm_picks=handle-1,handle-2
// so quiz result pages can land shoppers with their recommendations ticked.
function applyUrlPicks() {
  try {
    var raw = new URLSearchParams(window.location.search).get('vm_picks');
    if (!raw) return;
    var picks = raw.split(',').map(function(s) { return s.trim().toLowerCase(); }).filter(Boolean);
    if (!picks.length) return;
    SUPPLEMENTS.forEach(function(s) {
      if (s && s.handle && picks.indexOf(String(s.handle).toLowerCase()) !== -1) {
        selected.add(s.name);
      }
    });
  } catch (e) { /* older browsers without URLSearchParams: skip silently */ }
}

function fetchPage(page, accumulated) {
  return fetch('/products.json?collection_id=689515102547&limit=250&page=' + page)
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var products = data.products || [];
      accumulated = accumulated.concat(products);
      if (products.length === 250) {
        return fetchPage(page + 1, accumulated);
      }
      return accumulated;
    });
}

function syncCheckboxes(name, checked) {
  document.querySelectorAll('.vm-picker__checkbox[data-sup-name="' + CSS.escape(name) + '"]')
    .forEach(function(cb) { cb.checked = checked; });
  if (checked) selected.add(name); else selected.delete(name);
  updateCartBar();
}

function updateCartBar() {
  var bar     = document.getElementById('vm-cart-bar');
  var label   = document.getElementById('vm-cart-label');
  var totalEl = document.getElementById('vm-cart-total');
  var pdEl    = document.getElementById('vm-cart-perday');
  var n = selected.size;
  if (n === 0) { hide(bar); } else { if (bar) bar.style.display = 'flex'; }
  if (label) label.textContent = n + ' supplement' + (n === 1 ? '' : 's') + ' selected';
  var supMap = {};
  sorted.forEach(function(s) { supMap[s.name] = s; });
  var suppTotal = Array.from(selected).reduce(function(acc, name) {
    var sup = supMap[name];
    if (!sup || !sup.price) return acc;
    var p = parseFloat(sup.price.replace(/[^0-9.]/g, ''));
    return acc + (isNaN(p) ? 0 : p);
  }, 0);
  var total = BASE_PRICE + suppTotal;
  if (totalEl) totalEl.textContent = '£' + total.toFixed(2) + '/mo';
  if (pdEl) {
    var perDay = total / 31;
    pdEl.textContent = '≈ ' + (perDay < 1 ? Math.round(perDay * 100) + 'p' : '£' + perDay.toFixed(2)) + ' per day';
  }
}

function buildItem(sup) {
  var li = document.createElement('li');
  li.className = 'vm-picker__item';
  var safeData = encodeURIComponent(JSON.stringify(sup));
  var safeName = (sup.name || '').replace(/"/g, '&quot;');
  li.innerHTML =
    '<label class="vm-picker__check-wrap" aria-label="Select ' + safeName + '">' +
      '<input type="checkbox" class="vm-picker__checkbox" data-sup-name="' + safeName + '" ' + (selected.has(sup.name) ? 'checked' : '') + '>' +
      '<span class="vm-picker__checkmark"></span>' +
    '</label>' +
    '<span class="vm-picker__item-name">' + (sup.name || '') + '</span>' +
    '<span class="vm-picker__item-price">' + (sup.price ? sup.price + '<span class="vm-picker__permo">/mo</span>' : '') + '</span>' +
    '<button type="button" class="vm-picker__info-btn" aria-label="Info for ' + safeName + '" data-sup="' + safeData + '">&#9432;</button>';
  li.addEventListener('click', function(e) {
    if (e.target.closest('.vm-picker__info-btn')) return;
    if (e.target.closest('.vm-picker__check-wrap')) return;
    var cb = li.querySelector('.vm-picker__checkbox');
    cb.checked = !cb.checked;
    syncCheckboxes(cb.dataset.supName, cb.checked);
  });
  return li;
}

function buildUI() {
  // A-Z list
  try {
    var currentLetter = '';
    var azUl = document.createElement('ul');
    azUl.className = 'vm-picker__list vm-picker__az-items';
    sorted.forEach(function(s) {
      if (!s || !s.name) return;
      var letter = s.name[0].toUpperCase();
      if (letter !== currentLetter) {
        currentLetter = letter;
        var li = document.createElement('li');
        li.className = 'vm-picker__az-letter';
        li.textContent = letter;
        azUl.appendChild(li);
      }
      azUl.appendChild(buildItem(s));
    });
    var azList = document.getElementById('vm-az-list');
    if (azList) azList.appendChild(azUl);
  } catch(e) { console.error('VitaMonth picker: A-Z build error', e); }

  // Category accordions
  try {
    var catContainer = document.getElementById('vm-categories');
    if (catContainer) {
      CATEGORIES.forEach(function(cat) {
        var catDiv = document.createElement('div');
        catDiv.className = 'vm-picker__cat';
        var header = document.createElement('button');
        header.type = 'button';
        header.className = 'vm-picker__cat-header';
        header.style.backgroundColor = cat.color;
        header.setAttribute('aria-expanded', 'false');
        header.innerHTML =
          '<span class="vm-picker__cat-emoji">' + cat.emoji + '</span>' +
          '<span class="vm-picker__cat-name">' + cat.label + '</span>' +
          '<span class="vm-picker__cat-arrow">▾</span>';
        var body = document.createElement('div');
        body.className = 'vm-picker__cat-body';
        body.style.display = 'none';
        var ul = document.createElement('ul');
        ul.className = 'vm-picker__list';
        SUPPLEMENTS.filter(function(s) {
          return s && Array.isArray(s.cats) && s.cats.indexOf(cat.id) !== -1;
        }).sort(function(a, b) {
          return a.name.localeCompare(b.name);
        }).forEach(function(sup) { ul.appendChild(buildItem(sup)); });
        body.appendChild(ul);
        header.addEventListener('click', function() {
          var opening = isHidden(body);
          if (opening) { show(body); } else { hide(body); }
          header.setAttribute('aria-expanded', String(opening));
          header.querySelector('.vm-picker__cat-arrow').textContent = opening ? '▴' : '▾';
        });
        catDiv.appendChild(header);
        catDiv.appendChild(body);
        catContainer.appendChild(catDiv);
      });
    }
  } catch(e) { console.error('VitaMonth picker: categories build error', e); }

  // Search
  try {
    var searchInput    = document.getElementById('vm-search');
    var resultsSection = document.getElementById('vm-results-section');
    var resultsList    = document.getElementById('vm-results-list');
    var goalsSection   = document.getElementById('vm-goals-section');
    if (searchInput) {
      searchInput.addEventListener('input', function() {
        var q = searchInput.value.trim().toLowerCase();
        if (!q) { clearSearch(); return; }
        var matches = sorted.filter(function(s) { return s && s.name && s.name.toLowerCase().indexOf(q) !== -1; });
        if (resultsList) {
          resultsList.innerHTML = '';
          if (matches.length === 0) {
            resultsList.innerHTML = '<li class="vm-picker__no-results">No supplements found</li>';
          } else {
            matches.forEach(function(s) { resultsList.appendChild(buildItem(s)); });
          }
        }
        show(resultsSection);
        hide(goalsSection);
      });
    }
    function clearSearch() {
      if (searchInput) searchInput.value = '';
      hide(resultsSection);
      show(goalsSection);
    }
  } catch(e) { console.error('VitaMonth picker: search error', e); }

  // Checkbox delegation
  ['vm-supplement-picker', 'vm-results-section'].forEach(function(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.addEventListener('change', function(e) {
      var cb = e.target.closest('.vm-picker__checkbox');
      if (!cb) return;
      syncCheckboxes(cb.dataset.supName, cb.checked);
    });
  });

  // Info popup
  try {
    var popup   = document.getElementById('vm-info-popup');
    var overlay = document.getElementById('vm-info-overlay');
    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function showPopup(sup, anchorEl) {
      var info = BENEFITS[sup.handle] || { strength: '', benefits: [] };
      document.getElementById('vm-popup-name').textContent     = sup.name;
      document.getElementById('vm-popup-strength').textContent = info.strength;
      document.getElementById('vm-popup-price').textContent    = sup.price + ' / month';

      /* Product photo (pulled live from the Shopify catalogue) */
      var imgEl = document.getElementById('vm-popup-img');
      if (imgEl) {
        if (sup.img) {
          imgEl.src = sup.img;
          imgEl.alt = sup.name;
          imgEl.style.display = 'block';
        } else {
          imgEl.style.display = 'none';
          imgEl.removeAttribute('src');
          imgEl.alt = '';
        }
      }

      var bEl = document.getElementById('vm-popup-benefits');
      bEl.innerHTML = (info.benefits || []).map(function(b) {
        return '<span class="vm-picker__benefit-tag">' + esc(b) + '</span>';
      }).join('');

      /* Nutrition (per serving) + ingredients, from the manufacturer dataset.
         Anything not supplied is simply omitted - never substituted. */
      var nutri = NUTRITION[sup.handle] || null;
      var nutWrap  = document.getElementById('vm-popup-nut-wrap');
      var nutBody  = document.getElementById('vm-popup-nut');
      var servEl   = document.getElementById('vm-popup-serving');
      var ingWrap  = document.getElementById('vm-popup-ing-wrap');
      var ingEl    = document.getElementById('vm-popup-ing');
      var noteEl   = document.getElementById('vm-popup-note');
      var showNote = false;

      if (nutri && nutri.n && nutri.n.length) {
        if (servEl) servEl.textContent = nutri.s ? 'Serving size: ' + nutri.s : '';
        nutBody.innerHTML = nutri.n.map(function(row) {
          var label = String(row[0] || '');
          var isSub = label.charAt(0) === '\u2192';
          if (label.indexOf('\u2020') !== -1 || String(row[2] || '').indexOf('\u2020') !== -1) showNote = true;
          return '<tr' + (isSub ? ' class="is-sub"' : '') + '>' +
                   '<td>' + esc(label.replace(/^\u2192\s*/, '')) + '</td>' +
                   '<td>' + esc(row[1]) + '</td>' +
                   '<td>' + esc(row[2]) + '</td>' +
                 '</tr>';
        }).join('');
        nutWrap.style.display = '';
      } else if (nutWrap) {
        nutWrap.style.display = 'none';
        nutBody.innerHTML = '';
      }

      if (nutri && nutri.i) {
        ingEl.textContent = nutri.i;
        ingWrap.style.display = '';
      } else if (ingWrap) {
        ingWrap.style.display = 'none';
        ingEl.textContent = '';
      }

      if (noteEl) noteEl.style.display = showNote ? '' : 'none';

      if (popup) { popup.removeAttribute('aria-hidden'); popup.style.display = 'block'; }
      show(overlay);
      if (popup && window.innerWidth >= 750 && anchorEl) {
        var rect = anchorEl.getBoundingClientRect();
        var pr = document.getElementById('vm-supplement-picker').getBoundingClientRect();
        popup.style.cssText = 'display:block;position:absolute;top:' + (rect.bottom - pr.top + 8) + 'px;left:' + Math.min(rect.left - pr.left, pr.width - 300) + 'px;bottom:auto;transform:none;max-height:70vh;overflow-y:auto;';
      } else if (popup) {
        popup.style.cssText = 'display:block;position:fixed;bottom:72px;left:50%;transform:translateX(-50%);top:auto;max-height:70vh;overflow-y:auto;';
      }
      if (popup) popup.scrollTop = 0;
    }

    function closePopup() {
      if (popup) { popup.setAttribute('aria-hidden', 'true'); popup.style.display = 'none'; }
      hide(overlay);
    }
    var infoClose = document.getElementById('vm-info-close');
    if (infoClose) infoClose.addEventListener('click', closePopup);
    if (overlay) overlay.addEventListener('click', closePopup);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closePopup(); });
    var pickerEl = document.getElementById('vm-supplement-picker');
    if (pickerEl) {
      pickerEl.addEventListener('click', function(e) {
        var btn = e.target.closest('.vm-picker__info-btn');
        if (!btn) return;
        showPopup(JSON.parse(decodeURIComponent(btn.dataset.sup)), btn);
      });
    }
  } catch(e) { console.error('VitaMonth picker: popup error', e); }

  // Cart button
  try {
    var cartBtn = document.getElementById('vm-cart-btn');
    if (cartBtn) {
      cartBtn.addEventListener('click', function() {
        if (!selected.size) return;
        cartBtn.disabled = true;
        cartBtn.textContent = 'Adding...';
        var supMap = {};
        sorted.forEach(function(s) { supMap[s.name] = s; });
        var items = Array.from(selected).map(function(name) {
          var item = { id: supMap[name].variantId, quantity: 1 };
          if (SELLING_PLAN) item.selling_plan = SELLING_PLAN;
          return item;
        });

        // Always include the base VitaMonth subscription — but only once per cart.
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var baseInCart = (cart.items || []).some(function(it) {
              return it.variant_id === BASE_VARIANT || it.id === BASE_VARIANT;
            });
            if (!baseInCart && BASE_VARIANT) {
              var baseItem = { id: BASE_VARIANT, quantity: 1 };
              if (SELLING_PLAN) baseItem.selling_plan = SELLING_PLAN;
              items.unshift(baseItem);
            }
          })
          .catch(function() { /* if the cart check fails, proceed with supplements only */ })
          .then(function() {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble' })
            });
          })
          .then(function(resp) {
            if (!resp.ok) {
              return resp.json().then(function(err) {
                cartBtn.textContent = (err && err.description) || 'Error - try again';
                cartBtn.disabled = false;
              });
            }
            return resp.json().then(function(data) {
              cartBtn.textContent = 'Added!';
              // Refresh the theme's cart drawer with the re-rendered sections.
              // If the drawer isn't available, fall back to the cart page so the
              // shopper always sees their items.
              var refreshed = false;
              try {
                var drawer = document.querySelector('cart-drawer');
                if (drawer && typeof drawer.renderContents === 'function' && data && data.sections) {
                  // The theme puts 'is-empty' on <cart-drawer> itself (outside the
                  // re-rendered #CartDrawer), which keeps the item list hidden via CSS
                  // when the cart started empty. Stock Dawn removes it in
                  // product-form.js; do the same here.
                  drawer.classList.remove('is-empty');
                  drawer.renderContents(data);
                  var inner = drawer.querySelector('.drawer__inner');
                  if (inner) inner.classList.remove('is-empty');
                  refreshed = true;
                }
              } catch (e) {
                console.error('VitaMonth picker: cart drawer refresh failed', e);
              }
              if (!refreshed) {
                window.location.href = '/cart';
                return;
              }
              setTimeout(function() { cartBtn.textContent = 'Add to Cart'; cartBtn.disabled = false; }, 2500);
            });
          })
          .catch(function() {
            cartBtn.textContent = 'Error - try again';
            cartBtn.disabled = false;
          });
      });
    }
  } catch(e) { console.error('VitaMonth picker: cart error', e); }
}

// Fetch products then build everything
fetchPage(1, [])
  .then(function(all) {
    processProducts(all);
    applyUrlPicks();
    buildUI();
    updateCartBar();
  })
  .catch(function(err) {
    console.error('VitaMonth picker fetch error:', err);
    // Fallback: try Liquid-embedded data if present
    try {
      var dataEl = document.getElementById('vm-supp-data');
      if (dataEl) {
        var fb = JSON.parse(dataEl.value || dataEl.textContent);
        if (fb && fb.length) {
          SUPPLEMENTS = fb;
          sorted = SUPPLEMENTS.slice().sort(function(a, b) { return a.name.localeCompare(b.name); });
          applyUrlPicks();
          buildUI();
          updateCartBar();
        }
      }
    } catch(e) {}
  });
})();
